<template lang="html">

    <section class="coffee-list">

        <b-container class="coffee-list-row">
            <b-row cols="2" cols-md="4">
                <b-col v-for="coffee in coffees" :key="coffee.id" class="coffee-column py-3">
                    <div class="coffee-div" id="show-modal" @click="getCoffeeType(coffee)" v-b-modal.my-modal>
                        <b-img fluid :alt="coffee.name" :src="require(`@/assets/coffee/` + coffee.thumb)"></b-img>
                        <h5>{{ coffee.name }}</h5>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <transition name="modal">
            <CoffeeType v-if="showModal" @close="showModal = false" :coffee-name="coffeeToPass" />
        </transition>
    
    </section>

</template>

<script lang="js">

    import CoffeeType from "@/components/CoffeeType.vue";
    import coffeeData from '@/json/coffee.json';

    export default  {
        name: 'coffee-list',
        props: [],
        mounted () {

        },
        data () {
            return {
                showModal: false,
                coffeeToPass: null,

                coffees : coffeeData
            }
        },
        methods: {
            getCoffeeType(item) {
                this.showModal = true;
                this.coffeeToPass = item;
            }
        },
        computed: {

        },
        components: {
            CoffeeType
        }
    }

</script>

<style scoped lang="scss">
    
    .coffee-list {
        margin: auto;
        margin-top: 5rem;

        @media (max-width: 450px) {
            margin-top: 3rem;
        }
    }

    .coffee-column {
        //background-color: white;

        .coffee-div {
            padding: 20px 50px;
            background-color: white;
            border-radius: 25px;

            width: 100%;

            transition: box-shadow 0.5s ease;
            transition: transform 0.2s ease;

            @media (max-width: 450px) {
                padding: 15px 25px;
            }

            h5 {
                padding-top: 15px;
                text-align: center;
                font-family:'Poiret One', cursive;
            }

            &:hover {
                box-shadow: 0 10px 20px rgba($color: #9E9191, $alpha: 0.16);
                transform: scale(1.02);

                border: 2px dashed #BDD1E2;

                transition: box-shadow 0.5s ease;
                transition: transform 0.2s ease;
            }
        }

    }

    .modal-enter-active,
    .modal-leave-active {
        transition: opacity .5s;
    }

    .modal-enter,
    .modal-leave-to {
        opacity: 0;
    }
  
</style>
